import { forwardRef, useImperativeHandle, useRef } from "react";
import QRCode from "react-qr-code";

import {
  SHARED_QR_SIZE,
  SHARED_QR_ECL,
  svgElementToPngBlob,
} from "@/lib/qrImage";

/**
 * QR oculto, dedicado exclusivamente a generar la imagen que se comparte o
 * se guarda (con quiet zone). Nunca es visible en pantalla: se posiciona
 * fuera del viewport en vez de `display:none` para que la serialización del
 * SVG no dependa de ningún comportamiento de layout.
 *
 * El QR visible en cada vista (OrderPage, ShareOrderModal) queda intacto: no
 * comparte tamaño, nivel de corrección de errores ni margen con este nodo.
 */
export const HiddenShareQr = forwardRef(function HiddenShareQr(
  { value },
  ref,
) {
  const containerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    async toPngBlob(fallbackSvgElement) {
      const svgElement =
        containerRef.current?.querySelector("svg") || fallbackSvgElement;

      if (!svgElement) {
        throw new Error("SVG no encontrado.");
      }

      return svgElementToPngBlob(svgElement);
    },
  }));

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      style={{
        position: "absolute",
        left: -99999,
        top: 0,
        width: 0,
        height: 0,
        overflow: "hidden",
      }}
    >
      {value ? (
        <QRCode
          size={SHARED_QR_SIZE}
          level={SHARED_QR_ECL}
          bgColor="#FFFFFF"
          fgColor="#000000"
          value={value}
        />
      ) : null}
    </div>
  );
});
